/* eslint-disable jsx-a11y/no-redundant-roles */
import React from "react";

export default function Contact() {
  return (
    <>
      <section className="section pb-5">
        <div className="container">
          <div className="row mb-5 align-items-end">
            <div className="col-md-6" data-aos="fade-up">
              <h2>Contact Me</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-5 mb-md-0" data-aos="fade-up">
              <form action="https://formspree.io/f/xyyolgpp" method="post" role="form" className="php-email-form">
                <div className="row gy-3">
                  <div className="col-md-6 form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" name="name" className="form-control" id="name" required />
                  </div>
                  <div className="col-md-6 form-group">
                    <label htmlFor="name">Email</label>
                    <input type="email" className="form-control" name="email" id="email" required />
                  </div>
                  <div className="col-md-12 form-group">
                    <label htmlFor="name">Subject</label>
                    <input type="text" className="form-control" name="subject" id="subject" required />
                  </div>
                  <div className="col-md-12 form-group">
                    <label htmlFor="name">Message</label>
                    <textarea className="form-control" name="message" cols="30" rows="10" required></textarea>
                  </div>

                  <div className="col-md-12 my-3">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">Your message has been sent. Thank you!</div>
                  </div>

                  <div className="col-md-6 mt-0 form-group">
                    <input type="submit" className="readmore d-block w-100" value="Send Message" />
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-4 ml-auto order-2" data-aos="fade-up">
              <ul className="list-unstyled">
                <li className="mb-3">
                  <strong className="d-block mb-1">Address</strong>
                  <span>Mehmet Akif Ersoy Mahalle, Istanbul, Turkey</span>
                </li>
                <li className="mb-3">
                  <strong className="d-block mb-1">Phone</strong>
                  <span>+905397864507</span>
                </li>
                <li className="mb-3">
                  <strong className="d-block mb-1">Email</strong>
                  <span>waleedshahab01@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
